<template lang="html">
  <input
        type="date"
        ref="input"
        v-bind:value="dateToYYYYMMDD(value)"
        v-on:input="updateValue($event.target)"
        v-on:focus="selectAll"
      >
</template>

<script>
export default {
  name: 'vueDate',
  props: {
    value: {
      type: Date,
    }
  },
  methods: {
    dateToYYYYMMDD(date) {
      return date && date.toISOString().split('T')[0]
    },
    updateValue: function (target) {
      this.$emit('input', target.valueAsDate);
    },
    selectAll: function (event) {
      setTimeout(function () {
      	event.target.select()
      }, 0)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
